const AppealNameConstants: { [key: string]: any } = {
  0: 'Provider Was Underpaid',
  1: 'Provider Was Overpaid',
  2: 'N/A',
  3: 'Pay After Denial',
}
export default AppealNameConstants
